import { createTypedEnum } from '@reckon-web/formschema-enums';

export const JobStatusEnum = createTypedEnum({
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  Completed: 'Completed',
  Closed: 'Closed',
} as const);
export type JobStatusEnumValueType = (typeof JobStatusEnum.values)[number];
export type JobStatusEnumLabelType = (typeof JobStatusEnum.labels)[number];
